import { useSelector } from 'react-redux';
import type { AppState } from '@app/react/reducer';

type VoidH = () => void;

type RT = {
    showDialog: boolean;
    okHandler: VoidH;
    cancelHandler: VoidH;
};

export const useDialogState = (key: string): RT => {
    const selectShowDialog = (state: AppState): boolean => state.uiDialog.states[key]?.show || false;
    const selectOkHandler = (state: AppState): VoidH => state.uiDialog.states[key]?.okHandler;
    const selectCancelHandler = (state: AppState): VoidH => state.uiDialog.states[key]?.cancelHandler;

    const showDialog = useSelector(selectShowDialog);
    const okHandler = useSelector(selectOkHandler);
    const cancelHandler = useSelector(selectCancelHandler);

    return {
        showDialog,
        okHandler,
        cancelHandler,
    };
};
